<template>
	<view class="info" @click="toPage">
		<image :src="info.img" mode="widthFix"></image>
		<view class="info_shop">
			<view class="info_shop_title">
				<text>{{info.name}}</text>
			</view>
			<view class="info_shop_divide">
				<uni-rate :value="info.divide" size="18" color="#bbb" active-color="red" />
				<text>{{info.divide}}</text>
			</view>
			<view class="info_shop_address">
				<text>{{info.address}}</text>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		props: {
			info: {
				type: Object
			}
		},
		methods: {
			toPage() {
				this.$emit('getId', 12345678)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.info {
		width: 100%;
		height: 148rpx;
		background: #FFFFFF;
		box-shadow: 0rpx 4rpx 8rpx 0rpx rgba(0,0,0,0.04);
		border-radius: 12rpx;
		border: 2rpx solid #F5F5F5;
		display: flex;
		align-items: center;
		padding: 18rpx;
		box-sizing: border-box;
		image {
			width: 112rpx;
			height: 112rpx;
			flex-shrink: 0;
			border-radius: 10rpx;
			margin-right: 16rpx;
		}
		.info_shop {
			flex: 1;
			height: 100%;
			.info_shop_title {
				width: 540rpx;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				text {
					font-size: 28rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #333333;
				}
			}
			.info_shop_divide {
				display: flex;
				align-items: center;
				text {
					font-size: 24rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #D20A0A;
					margin-left: 10rpx;
				}
			}
			.info_shop_address {
				width: 540rpx;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				text {
					font-size: 24rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #999999;
				}
			}
		}
	}
</style>